import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getDialogMessagesAction,
  migrationToNewApiAction,
  startDialogAction,
  startDialogWithCompletionsAction,
  uploadFileToDialogAction,
} from "./actions";
import type { DialogsState } from "./types";

export function startDialogReducerBuilder(
  builder: ActionReducerMapBuilder<DialogsState>,
) {
  builder.addCase(startDialogAction.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(startDialogAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.messages = action.payload;
    state.isMessageLoading = false;
  });
  builder.addCase(startDialogAction.rejected, (state) => {
    state.isMessageLoading = false;
  });
}

export function startDialogWithCompletionsReducerBuilder(
  builder: ActionReducerMapBuilder<DialogsState>,
) {
  builder.addCase(startDialogWithCompletionsAction.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(
    startDialogWithCompletionsAction.fulfilled,
    (state, action) => {
      if (!action.payload) return;
      state.dialogValue = action.payload;
      state.isMessageLoading = false;
    },
  );
  builder.addCase(startDialogWithCompletionsAction.rejected, (state) => {
    state.isMessageLoading = false;
  });
}

export function getDialogMessagesReducerBuilder(
  builder: ActionReducerMapBuilder<DialogsState>,
) {
  builder.addCase(getDialogMessagesAction.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(getDialogMessagesAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.messages = action.payload;
    state.isMessageLoading = false;
  });
  builder.addCase(getDialogMessagesAction.rejected, (state) => {
    state.isMessageLoading = false;
  });
}

export function migrationToNewApiReducerBuilder(
  builder: ActionReducerMapBuilder<DialogsState>,
) {
  builder.addCase(migrationToNewApiAction.pending, (state) => {
    state.isMessageLoading = true;
  });
  builder.addCase(migrationToNewApiAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    state.dialogValue = action.payload;
    state.isMessageLoading = false;
  });
  builder.addCase(migrationToNewApiAction.rejected, (state) => {
    state.isMessageLoading = false;
  });
}

export function uploadFileToDialogReducerBuilder(
  builder: ActionReducerMapBuilder<DialogsState>,
) {
  builder.addCase(uploadFileToDialogAction.pending, (state) => {
    state.isFileLoading = true;
  });
  builder.addCase(uploadFileToDialogAction.fulfilled, (state) => {
    state.isFileLoading = false;
  });
  builder.addCase(uploadFileToDialogAction.rejected, (state) => {
    state.isFileLoading = false;
  });
}
